<template>
    <el-dialog visible width="42%"  @close="onCancel" title="">
      <div class="flex">
        <img src="@/assets/img/Important.png" class="authorise-icon">
        <div class="flex-1 custom-pwd-info">
          <p class="authorise-title">{{ $t("pdwComplexity.important") }}</p>
          <p class="policy-tips" v-html="$t('pdwComplexity.tips')">
          </p>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <div type="primary" class="btn-ok" @click="onConfirm">
          <p>{{ $t("pdwComplexity.ok") }}</p>
          <p class="mt-10 tips">{{ $t("pdwComplexity.okTips") }}</p>
        </div>
        <div class="btn-no" @click="onNoConfirm">
          <p>{{ $t("pdwComplexity.noted") }}</p>
          <p class="mt-10 tips">{{ $t("pdwComplexity.notedTips") }}</p>
        </div>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import SvgIcon from "@/components/svgIcon/index";
  
  export default {
    name: "PwdComplexity",
    components: {
      SvgIcon,
    },
    props: {
      onCancel: {
        type: Function,
        default: () => {},
      },
      onConfirm: {
        type: Function,
        default: () => {},
      },
      onNoConfirm: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      ...mapGetters("common", {
        getUser: "getUser",
        getSite: "getSite",
      }),
    },
    watch: {},
    data() {
      return {
      };
    },
  
    mounted() {},
    methods: {
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .el-dialog .el-dialog__header {
    background-color: transparent;
    border-bottom: none;
    position: relative;
    min-height: 40px;
  }
  ::v-deep .el-dialog .el-dialog__body{
    padding-top:0;
  }
  ::v-deep .el-dialog .el-dialog__footer{
    border:0;
  }
  .authorise-icon{
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
  .dialog-footer{
    display: flex;
    justify-content: left;
    padding-left: 80px;
  }
  .authorise-title{
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
    color: rgb(24, 68, 225);
  }
  .policy-tips{
    font-size: 18px;
    word-break: break-word;
    line-height: 24px;
  }
  .p-15{
    padding: 20px;
  }
  .authorise-steps{
    height: 80px;
  }
  .btn-ok{
    padding: 10px 15px;
    border:1px solid rgb(126, 151, 238);
    border-radius: 4px;
    margin-right: 15px;
    cursor: pointer;
    text-align: left;
    color:rgb(24, 68, 225);
    font-weight: bolder;
    width: 50%;
  }
  .btn-no{
    padding: 10px 15px;
    cursor: pointer;
    border:1px solid #e5e5e5;
    border-radius: 4px;
    text-align: left;
    font-weight: bolder;
    width: 50%;
  }
  .tips {
    font-size: 16px;
    font-weight: normal;
  }
  .authorise-dlg-title img{
    width: 30px;
    margin-right: 20px;
    margin-left: 20px;
  }
  </style>
  